export enum PayableInvoiceServiceType {
  CUSTOMS_DUTIES = 'CUSTOMS_DUTIES',
  CUSTOMS_CLEARANCE = 'CUSTOMS_CLEARANCE',
}
